module.exports = __webpack_public_path__ + "pen.png?f4a6e867202d6f3d42062b1d46b04afa";